import { ModuleDeviceRequirements } from "features/module/types";

export const assetParameters = {
  default: {}
};

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 300,
  desktopOnly: false
};
